<script>
import Vue from 'vue'
import { AgGridVue } from 'ag-grid-vue'
import GridAutocomplete from '@/components/SigmaClientNew/GridAutocomplete.vue'
import { VendorResource, AccountResource, AddressResource, CityResource, StateResource, CountryResource } from '@sigmacloud/sigma-client/dist/resources'
import AgGridColumnMethodMixins from '@/Mixins/SigmaClientNew/AgGridColumnMethods'
import * as XLSX from 'xlsx'

export default Vue.extend({
  name: 'VendorList',

  components: {
    AgGridVue,
    GridAutocomplete
  },
  mixins: [ AgGridColumnMethodMixins ],

  props: {
    name: {
      required: false,
      type: String,
      default: 'vendorgrid'
    },

    classes: {
      required: false,
      type: String,
      default: 'ag-theme-balham'
    },

    rowData: {
      required: false
    },

    columns: {
      required: false,
      type: Array,
      default: undefined
    },

    options: {
      required: false,
      type: Object,
      default: undefined
    }
  },

  data () {
    return {
      isValidating: false,
      isSaving: false,
      iteration: 0,
      file: undefined,
      dropzoneVisible: false,
      rows: [],
      states: [],
      contries: []
    }
  },
  methods: {
    /*
      Columns:
      0  => Name of Vendor
      1  => Payee Name
      2  => Description
      3  => FEIN or SSN
      4  => Vendor Type
      5  => Work State
      6  => Payment Type
      7  => Main Address 1
      8  => Main City
      9  => Main State
      10 => Main Postal
      11 => Main Country
      12 => Email
      13 => Cell Phone
      14 => Home Phone
      15 => Default Account
      16 => Default Free Fields
      17 => Default Tax Codes
      18 => ACH Account Number
      19 => ACH Routing Number
      20 => Petty Cash Vendor?
      21 => Petty Cash Account
      22 => Petty Cash Custodian
      23 => Petty Cash Custodian Account
      24 => P-card Vendor?
      25 => P-card Account
      26 => Account Number
      27 => Terms
    */
    parseExcel (event) {
      this.file = event.target.files && event.target.files[0] ? event.target.files[0] : null

      if (this.file) {
        const reader = new FileReader()

        reader.onload = (e) => {
          /* Parse data */
          const bstr = e.target.result
          const wb = XLSX.read(bstr, { type: 'binary' })
          const wsname = wb.SheetNames[0]
          const ws = wb.Sheets[wsname]
          const data = XLSX.utils.sheet_to_json(ws, { header: 1 })

          let rows = []
          for (const i in data) {
            const line = data[i]
            // Skip header and vendors with no names
            if (line[0] && typeof line[0] === 'string' && line[0].match(/^name/i)) continue
            if (!line[0]) continue
            let row = {
              name: line[0],
              payee_name: line[1] || line[0],
              description: line[2],
              tax_id: line[3],
              entity_type: line[4],
              work_state: line[5],
              default_payment_type: line[6],
              mainAddress: line[7],
              mainCity: line[8],
              mainState: line[9],
              mainPostal: line[10],
              mainCountry: line[11],
              email: line[12],
              phone_cell: line[13],
              phone_home: line[14],
              defaultAccount: line[15],
              defaultFreeFields: line[16],
              deFaultTaxCodes: line[17],
              achAccountNumber: line[18],
              achRoutingNumber: line[19],
              pettyCashVendor: line[20],
              pettyCashAccount: line[21],
              pettyCashCustodian: line[22],
              pettyCashCustodianAccount: line[23],
              pcardVendor: line[24],
              pcardAccount: line[25],
              accountNumber: line[26],
              due_days: line[27],
              error: null
            }
            rows.push(row)
          }

          this.rows = rows
          this.iteration++
          this.checkVendors(rows)
          return rows
        }

        reader.readAsArrayBuffer(this.file)
        return this.rows
      }
    },

    async checkVendors (data) {
      if (!data) return true
      this.isValidating = true

      this.states = (await StateResource.all({ query: { page_size: 100 } })).map((resource) => resource)
      this.countries = (await CountryResource.all()).map((resource) => resource)

      for (const i in data) {
        let importedVendor = data[i]
        let resource

        // Major errors
        if (!importedVendor) importedVendor.error = true
        else if (!importedVendor.name) importedVendor.error = true
        else if (!importedVendor.payee_name) importedVendor.error = true
        if (importedVendor.error) continue

        // Check for dupes
        if (importedVendor.tax_id) {
          let query = {
            tax_id: String(importedVendor.tax_id)
          }
          resource = VendorResource.wrap('/validate')
          const result = await resource.post(query)
          if (result && result.data && result.data.status !== 'success') {
            importedVendor.error = 'Tax ID exists in the system'
          }
        }

        // Check State/Country Codes
        if (importedVendor.mainState) {
          const stateResource = this.states.find(({attributes}) => {
            return attributes.code === importedVendor.mainState || ((attributes.name || '').toLowerCase() === (importedVendor.mainState || '').toLowerCase())
          })
          if (!stateResource) importedVendor.error = 'State does not exist in this database'
        }
        if (importedVendor.mainCountry) {
          const countryResource = this.countries.find(({attributes}) => {
            return attributes.code === importedVendor.mainCountry || ((attributes.name || '').toLowerCase() === (importedVendor.mainCountry || '').toLowerCase())
          })
          if (!countryResource) importedVendor.error = 'Country does not exist in this database'
        }
        // if (importedVendor.name) {
        //   let query = {
        //     name: String(importedVendor.name)
        //   }
        //   if (!resource) resource = VendorResource.wrap('/validate')
        //   const result = await resource.post(query)
        //   if (result && result.data && result.data.status !== 'success') {
        //     importedVendor.error = 'Vendor Name exists in the system'
        //   }
        // }
      }

      this.isValidating = false
      this.$refs[this.name].gridOptions.api.redrawRows()
    },

    async uploadVendors () {
      this.isSaving = true
      for (const i in this.rows) {
        let record = this.rows[i]
        if (record.error) {
          console.log('Skipping ' + record.name)
          continue
        }

        await this.uploadVendor(record)
      }
      this.isSaving = false
    },

    async uploadVendor (vendorData) {
      let resource = new VendorResource()

      const directResourceFields = [ 'name', 'payee_name', 'description', 'tax_id', 'entity_type', 'work_state', 'default_payment_type', 'email', 'phone_cell', 'phone_home' ]
      directResourceFields.forEach((field) => {
        resource.set(field, vendorData[field])
      })

      if (vendorData.mainAddress && vendorData.mainState) {
        const stateResources = await this.resources.StateResource.list({ query: { code: vendorData.mainState } })
        const countryResources = await this.resources.CountryResource.list({ query: { name: vendorData.mainCountry } })
        const address = {
          line1: vendorData.mainAddress || '',
          line2: '',
          city: vendorData.mainCity || '',
          postal: vendorData.mainPostal || '',
          state: stateResources.resources[0].id || null,
          contact_email: vendorData.email || '',
          contact_phone: vendorData.phone_cell || vendorData.phone_home || '',
          country: countryResources.resources && countryResources.resources[0] && countryResources.resources[0].id ? countryResources.resources[0].id : 1
        }

        const newAddressResource = await this.createNewAddress(address, {})
        resource.set('default_address', 'CONTACT')
        resource.set('address_contact_id', newAddressResource.id)
        resource.set('address_selected_id', newAddressResource.id)
      }

      resource.validate()
      await resource.save()
    }
  },

  computed: {
    resources () {
      return {
        VendorResource,
        AccountResource,
        AddressResource,
        CityResource,
        StateResource,
        CountryResource
      }
    },
    height () {
      // Reducing by 3 % to handle sigma-frontend navbar
      return window.innerHeight * 0.73 + 'px'
    },
    width () {
      return '100%'
    }
  },

  mounted () {
  },

  beforeMount () {
    let instance = this.$store.getters.getActiveInstance
    let instanceUrl = (instance.url.endsWith('/') ? instance.url.slice(0, -1) : instance.url)
    let path = this.$route.path.includes('pettycash') ? `/pcs/${this.$route.params.id}` : this.$route.path

    this.defaultColDefs = [
      {
        headerName: 'Vendor Name',
        field: 'name',
        maxWidth: 300,
        minWidth: 150,
        editable: false,
        sortable: true,
        menuTabs: []
      },
      {
        headerName: 'Payee Name',
        field: 'payee_name',
        maxWidth: 300,
        minWidth: 150,
        editable: false,
        sortable: true,
        menuTabs: []
      },
      {
        headerName: 'Description',
        field: 'description',
        maxWidth: 300,
        minWidth: 150,
        editable: false,
        sortable: true,
        menuTabs: []
      },
      {
        headerName: 'FEIN/SSN',
        field: 'tax_id',
        maxWidth: 150,
        minWidth: 150,
        editable: false,
        sortable: true,
        menuTabs: []
      },
      {
        headerName: 'Vendor Type',
        field: 'entity_type',
        maxWidth: 150,
        minWidth: 150,
        editable: false,
        sortable: true,
        menuTabs: []
      },
      {
        headerName: 'Work State',
        field: 'work_state',
        maxWidth: 100,
        minWidth: 50,
        editable: false,
        sortable: true,
        menuTabs: []
      },
      {
        headerName: 'Default Payment',
        field: 'default_payment_type',
        maxWidth: 100,
        minWidth: 100,
        editable: false,
        sortable: true,
        menuTabs: []
      },
      {
        headerName: 'Address',
        field: 'mainAddress',
        maxWidth: 300,
        minWidth: 100,
        editable: false,
        sortable: true,
        menuTabs: []
      },
      {
        headerName: 'City',
        field: 'mainCity',
        maxWidth: 150,
        minWidth: 50,
        editable: false,
        sortable: true,
        menuTabs: []
      },
      {
        headerName: 'State',
        field: 'mainState',
        maxWidth: 70,
        minWidth: 50,
        editable: false,
        sortable: true,
        menuTabs: []
      },
      {
        headerName: 'Postal',
        field: 'mainPostal',
        maxWidth: 70,
        minWidth: 50,
        editable: false,
        sortable: true,
        menuTabs: []
      },
      {
        headerName: 'Country',
        field: 'mainCountry',
        maxWidth: 70,
        minWidth: 50,
        editable: false,
        sortable: true,
        menuTabs: []
      },
      {
        headerName: 'Email',
        field: 'email',
        maxWidth: 200,
        minWidth: 100,
        editable: false,
        sortable: true,
        menuTabs: []
      },
      {
        headerName: 'Mobile Phone',
        field: 'phone_cell',
        maxWidth: 130,
        minWidth: 130,
        editable: false,
        sortable: true,
        menuTabs: []
      },
      {
        headerName: 'Home Phone',
        field: 'phone_home',
        maxWidth: 130,
        minWidth: 130,
        editable: false,
        sortable: true,
        menuTabs: []
      },
      /*
      {
        headerName: 'Default Account(s)',
        field: 'defaultAccount',
        maxWidth: 150,
        minWidth: 100,
        editable: false,
        sortable: true,
        menuTabs: []
      },
      {
        headerName: 'Default FF(s)',
        field: 'defaultFreeFields',
        maxWidth: 150,
        minWidth: 100,
        editable: false,
        sortable: true,
        menuTabs: []
      },
      {
        headerName: 'Default Tax Code(s)',
        field: 'defaultTaxCodes',
        maxWidth: 150,
        minWidth: 100,
        editable: false,
        sortable: true,
        menuTabs: []
      },
      {
        headerName: 'ACH Account #',
        field: 'achAccountNumber',
        maxWidth: 100,
        minWidth: 100,
        editable: false,
        sortable: true,
        menuTabs: []
      },
      {
        headerName: 'ACH Routing #',
        field: 'achRoutingNumber',
        maxWidth: 100,
        minWidth: 100,
        editable: false,
        sortable: true,
        menuTabs: []
      },
      {
        headerName: 'Petty Cash Vendor?',
        field: 'pettyCashVendor',
        maxWidth: 100,
        minWidth: 100,
        editable: false,
        sortable: true,
        menuTabs: []
      },
      {
        headerName: 'Petty Cash Account',
        field: 'pettyCashAccount',
        maxWidth: 100,
        minWidth: 100,
        editable: false,
        sortable: true,
        menuTabs: []
      },
      {
        headerName: 'Petty Cash Custodian',
        field: 'pettyCashCustodian',
        maxWidth: 100,
        minWidth: 100,
        editable: false,
        sortable: true,
        menuTabs: []
      },
      {
        headerName: 'Petty Cash Custodian Account',
        field: 'pettyCashCustodianAccount',
        maxWidth: 100,
        minWidth: 100,
        editable: false,
        sortable: true,
        menuTabs: []
      },
      {
        headerName: 'P-Card Vendor?',
        field: 'pcardVendor',
        maxWidth: 100,
        minWidth: 100,
        editable: false,
        sortable: true,
        menuTabs: []
      },
      {
        headerName: 'P-Card Account',
        field: 'pcardAccount',
        maxWidth: 100,
        minWidth: 100,
        editable: false,
        sortable: true,
        menuTabs: []
      },
      {
        headerName: 'Customer Account #',
        field: 'accountNumber',
        maxWidth: 100,
        minWidth: 100,
        editable: false,
        sortable: true,
        menuTabs: []
      },
      */
      {
        headerName: 'Errors',
        field: 'error',
        maxWidth: 500,
        minWidth: 200,
        editable: false,
        sortable: true,
        menuTabs: []
      }
    ]

    this.defaultGridOptions = {
      singleClickEdit: false,
      undoRedoCellEditing: false,
      enterMovesDown: true,
      enterMovesDownAfterEdit: true,
      rowSelection: 'multiple',
      columnDefs: this.columnDefs,
      defaultColDef: {
        resizable: true,
        menuTabs: []
      },
      frameworkComponents: {
        gridAutocomplete: GridAutocomplete
      },
      rowClassRules: {
        'ag-error': (params) => (params.data.error)
      }

      /*
      onGridReady: (params) => {
        this.onGridReady(params)
      },
      onFirstDataRendered: (params) => {
        this.onFirstDataRendered(params)
      },
      onCellValueChanged: (params) => {
        this.onCellValueChanged(params)
        // this.highlightCell()
      }
      */
    }

    this.dzOptions = {
      acceptedFiles: '.xls,.xlsx',
      autoProcessQueue: true,
      maxFileSize: 8,
      uploadMultiple: false,
      parallelUploads: 1,
      // fileImportUrl: instanceUrl + '/' + payload.importEndpoint
      // maxFiles: 5,
      thumbnailHeight: 20,
      url: instanceUrl + path
    }
  }
})
</script>

<style scoped>
  .m-top-20 { margin-top: 20px; }
  .m-bottom-20 { margin-bottom: 20px; }
  a, a:visited {
    text-decoration: none;
    color: rgb(0, 0, 238) !important;
  }
</style>

<template>
  <div style="width: 100%;" class="sigma-client-new">
    <div class="m-top-20 m-bottom-20">
      <h3>Step 1: Upload a spreadsheet</h3>
      <input style="width: 100%;" type="file" @change="parseExcel" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"/>
    </div>
    <h3>Step 2: Review Vendors</h3>
      <el-button type="info" @click="uploadVendors" :disabled="isValidating || isSaving"><span class="bold">Upload</span></el-button>
      <span v-if="isValidating">
        <b-spinner class="mr-2" /><span class="red bold">Checking for Duplicates. Please wait...</span>
      </span>
      <span v-if="isSaving">
        <b-spinner class="mr-2" /><span class="red bold">Adding Vendors. Please wait...</span>
      </span>
    <ag-grid-vue
      :name="name"
      :ref="name"
      :class="classes"
      :style="{ width, height }"
      :key="iteration"
      :column-defs="defaultColDefs"
      :grid-options="defaultGridOptions"
      :row-data="rows"
    />
  </div>
</template>



// WEBPACK FOOTER //
// src/components/SigmaClientNew/VendorImport.vue